// extracted by mini-css-extract-plugin
export default {"transparent":"ExpandableDetails_transparent__BVLUc"};